const DownloadInvoiceIcon = ({
  color = "#2B363B",
  width = 26,
  height = 26,
  opacity = 1,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.33334 14.1663V15.833C3.33334 16.275 3.50894 16.699 3.8215 17.0115C4.13406 17.3241 4.55798 17.4997 5.00001 17.4997H15C15.442 17.4997 15.866 17.3241 16.1785 17.0115C16.4911 16.699 16.6667 16.275 16.6667 15.833V14.1663M5.83334 9.16634L10 13.333M10 13.333L14.1667 9.16634M10 13.333V3.33301"
      stroke={color}
      stroke-opacity={opacity}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownloadInvoiceIcon;
